import { createSignal } from 'solid-js'
import * as api from '../api/endpoints/candidate-notifications.api'
import type { CandidateNotification } from '../features/candidate-notifications/types'

interface State {
  notifications: CandidateNotification[]
  unread: number
  lastFetched: Date | null
}

const [state, setState] = createSignal<State>({ notifications: [], unread: 0, lastFetched: null })

export const candidateNotificationStore = {
  get state() {
    return state()
  },
  get notifications() {
    return state().notifications
  },
  get unreadCount() {
    return state().unread
  },
  async fetch() {
    try {
      const [list, count] = await Promise.all([
        api.listCandidateNotifications(),
        api.getUnreadCount(),
      ])
      setState({
        notifications: list.notifications ?? [],
        unread: count.unread ?? 0,
        lastFetched: new Date(),
      })
    } catch (e) {
      console.error('Failed to fetch candidate notifications:', e)
    }
  },
  async markAsRead(id: number) {
    try {
      await api.markRead(id)
      setState((s) => ({
        ...s,
        notifications: s.notifications.map((n) => (n.id === id ? { ...n, is_read: true } : n)),
        unread: Math.max(0, s.unread - 1),
      }))
    } catch (e) {
      console.error(e)
    }
  },
  async markAllAsRead() {
    try {
      await api.markAllRead()
      setState((s) => ({
        ...s,
        notifications: s.notifications.map((n) => ({ ...n, is_read: true })),
        unread: 0,
      }))
    } catch (e) {
      console.error(e)
    }
  },
  clear() {
    setState({ notifications: [], unread: 0, lastFetched: null })
  },
}
